import axios from './_defaults/api';

export async function getReward() {
    try {
        const response = await axios.get("/rewards");
        return response?.data?.[0];
    } catch (error) {
        console.log('Errore getReward', error);
        throw error;
    }
}

export async function createRewardCoupons({rewardId}) {
    try {
        const response = await axios.post(`/rewards/${rewardId}/coupons`);
        return response?.data;
    } catch (error) {
        console.log('Errore createRewardCoupons', error);
        throw error;
    }
}